import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EndUserInstanceLocationType } from "../types/EndUserInstanceLocationType";
import { apiClient } from "src/utils/Api/apiClient";

interface endUserInstanceLocationState {
        endUserInstanceLocation: EndUserInstanceLocationType;
        endUserInstanceLocationLoading: boolean;
        endUserInstanceLocationError: string | null;
}

const initialState: endUserInstanceLocationState = {
        endUserInstanceLocation: {
                Id: 0,
                EndUserInstanceLocationId: "",
                EndUserInstanceId: 0,
                LocationName: "",
                NumberOfDoors: 0,
                LocationNumber: null,
                MACAddress: "",
                SalesOrderNumber: 0,
                ConnectionStatus: 0,
                ConnectionStatusString: "",
                TimezoneOffset: null,
                DST: 0,
                Version: "",
                UpdateRequired: false
        },
        endUserInstanceLocationLoading: false,
        endUserInstanceLocationError: null
}

export const createEndUserInstanceLocation = createAsyncThunk(
        'endUserInstanceLocation/createEndUserInstanceLocation',
        async (endUserInstanceLocationData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.post('endUserInstanceLocation/createEndUserInstanceLocation', endUserInstanceLocationData);
                        return response.data;
                } catch (endUserInstanceLocationError: any) {
                        return rejectWithValue(endUserInstanceLocationError.response.data || 'An error occured');
                }
        }
);

export const updateEndUserInstanceLocation = createAsyncThunk(
        'endUserInstanceLocation/updateEndUserInstanceLocation',
        async (endUserInstanceLocationData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.post('endUserInstanceLocation/updateEndUserInstanceLocation', endUserInstanceLocationData).then();
                        return response.data;
                } catch (endUserInstanceLocationError: any) {
                        return rejectWithValue(endUserInstanceLocationError.response.data || 'An error occured');
                }
        }
);

export const getEndUserInstanceLocationById = createAsyncThunk(
        'endUserInstanceLocation/getEndUserInstanceLocationById',
        async (endUserInstanceLocationData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.get(`endUserInstanceLocation/getEndUserInstanceLocationByID/${endUserInstanceLocationData}`);
                        return response.data;
                } catch (endUserInstanceLocationError: any) {
                        return rejectWithValue(endUserInstanceLocationError.response.data || 'An error occured');
                }
        }
);

const endUserInstanceLocationSlice = createSlice({
        name: 'endUserInstanceLocation',
        initialState,
        reducers: {
                endUserInstanceLocationReset: () => initialState,
        },
        extraReducers: (builder) => {
                //add endUsers to server
                builder.addCase(createEndUserInstanceLocation.pending, (state) => {
                        state.endUserInstanceLocationLoading = true;
                        state.endUserInstanceLocationError = null;
                });
                builder.addCase(createEndUserInstanceLocation.fulfilled, (state, action) => {
                        state.endUserInstanceLocationLoading = false;
                        state.endUserInstanceLocation = action.payload;
                });
                builder.addCase(createEndUserInstanceLocation.rejected, (state, action) => {
                        state.endUserInstanceLocationLoading = false;
                        state.endUserInstanceLocationError = action.payload as string;
                });
                //update endUsers to server
                builder.addCase(updateEndUserInstanceLocation.pending, (state) => {
                        state.endUserInstanceLocationLoading = true;
                        state.endUserInstanceLocationError = null;
                });
                builder.addCase(updateEndUserInstanceLocation.fulfilled, (state, action) => {
                        state.endUserInstanceLocationLoading = false;
                        state.endUserInstanceLocation = action.payload;
                });
                builder.addCase(updateEndUserInstanceLocation.rejected, (state, action) => {
                        state.endUserInstanceLocationLoading = false;
                        state.endUserInstanceLocationError = action.payload as string;
                });
                //get endUsers by ID from server
                builder.addCase(getEndUserInstanceLocationById.pending, (state) => {
                        state.endUserInstanceLocationLoading = true;
                        state.endUserInstanceLocationError = null;
                });
                builder.addCase(getEndUserInstanceLocationById.fulfilled, (state, action) => {
                        state.endUserInstanceLocationLoading = false;
                        state.endUserInstanceLocation = action.payload;
                });
                builder.addCase(getEndUserInstanceLocationById.rejected, (state, action) => {
                        state.endUserInstanceLocationLoading = false;
                        state.endUserInstanceLocationError = action.payload as string;
                });
        }
});

export const { endUserInstanceLocationReset } = endUserInstanceLocationSlice.actions;
export default endUserInstanceLocationSlice.reducer;
